<ion-content>
	<div class="improve_header">
		<h1>Betrag erhöhen</h1>
		<ion-button class="modal_close" (click)="closeModal()" fill="clear">
			<ion-icon slot="icon-only" name="close-outline"></ion-icon>
		</ion-button>
		<!-- <ion-button class="modal_close" type="button" expand="block" color="white" fill="clear" (click)="closeModal()"
			>Close</ion-button
		> -->
	</div>
	<p>Der neue Betrag muss größer {{ amount }} sein.</p>
	<form [formGroup]="rForm" #formDirective="ngForm">
		<div class="input-group">
			<ion-item fill="outline">
				<ion-label position="floating">Betrag</ion-label>
				<ion-input type="number" formControlName="amount"></ion-input>
			</ion-item>
			<div
				*ngIf="(rForm.get('amount')?.dirty || rForm.get('amount')?.touched) && rForm.get('amount')?.errors"
				class="errors">
				<span *ngIf="rForm.get('amount')?.hasError('required')">Betrag notwendig</span>
				<span *ngIf="rForm.get('amount')?.hasError('min')">Mindesteinsatz 5 €</span>
			</div>
		</div>
		<ion-button type="button" (click)="submitForm()" expand="block" disabled="{{ smallerAmount }}"
			>Herausforderung erhöhen</ion-button
		>
	</form>
</ion-content>
